import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Row, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useStoreVsVillagePages from '../useSalesTrackingsGenderAge';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';
import Helpers from '../../../../../helpers';

const MainPage = () => {
  const {
    data,
    filters,
    title,
    loading,
    handleDownloadExcel,
    searchParams,
    format,
    loadingPdf,
    handleDownloadPdf,
    errors,
  } = useStoreVsVillagePages();
  const { t } = useTranslation();

  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  return (
    <>
      <PageHeader title={'SALES TRACKING: age/gender'}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage errors={errors} searchParams={searchParams} />
        {byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <BarChangeChart
                  keys={['Sesso']}
                  data={data.chart1}
                  format={format}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  lineMargins={{ top: 50, right: 300, bottom: 100, left: 210 }}
                  lineAxisRightTickPadding={170}
                  lineTickSize={0}
                  lineFormat={(v) => `€${v}`}
                  lineMinValue={0}
                />
              </Col>
              <Col span={12}>
                <BarChangeChart
                  keys={['Maschi', 'Femmine']}
                  data={data.chart2}
                  format={(v) => Helpers.changeDotToComa(format(v))}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  hideLine
                />
              </Col>
              <Col span={12}>
                <BarChangeChart
                  keys={['Età ']}
                  data={data.chart3}
                  format={format}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  lineMargins={{ top: 50, right: 200, bottom: 100, left: 100 }}
                  lineAxisRightTickPadding={100}
                  lineTickSize={0}
                  lineFormat={(v) => `€${v}`}
                  lineMinValue={0}
                  hideMarker
                />
              </Col>
              <Col span={12}>
                <BarChangeChart
                  keys={['Incidenza per provincia']}
                  data={data.chart4}
                  format={format}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                  hideMarker
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default MainPage;
